const CustomJsSelectBox =  {
    openedSelectBox: null,
    initializedDocumentClickHandler: false,

    translations: {
        cs: {
            Searching: 'Vyhledávání',
            NoItems: 'Žádné položky',
        },
        sk: {
            Searching: 'Vyhľadávanie',
            NoItems: 'Žiadne položky',
        },
        en: {
            Searching: 'Searching',
            NoItems: 'No items',
        },
        fr: {
            Searching: 'Chercher',
            NoItems: 'Aucun article',
        },
        it: {
            Searching: 'Ricerca',
            NoItems: 'Nessun articolo',
        },
        es: {
            Searching: 'Búsqueda',
            NoItems: 'No hay artículos',
        },
        de: {
            Searching: 'Suche',
            NoItems: 'Keine Artikel',
        },
    },

    init(selectNode) {
        let self = this;

        if (selectNode) {
            self._constructSelectBox(selectNode);
        } else {
            document.querySelectorAll('.js-custom-select:not(.js-select-initialized)').forEach(selectNode => {
                self._constructSelectBox(selectNode);
            });
        }

        if (! self.initializedDocumentClickHandler) {
            document.addEventListener('click', (event) => {
                if (! self.openedSelectBox) {
                    return;
                }

                if (
                    ! self.openedSelectBox._customSelectNode.contains(event.target)
                    && self.openedSelectBox !== event.target
                ) {
                    self._close(self.openedSelectBox);
                }
            });
            self.initializedDocumentClickHandler = true;
        }
    },

    switchGroup(selectNode, group) {
        let self = this;

        selectNode._customSelectActiveGroup = group ? group : null;
        self._updateItemsVisibilityState(selectNode);
        self._updateSelectedItem(selectNode);
    },

    _constructSelectBox(selectNode) {
        let self = this;
        let noItemsNode;
        let optionsNodes = Array.prototype.slice.call(selectNode.options);

        selectNode._customSelectEnableSearch = selectNode.dataset.enableSearch !== 'false';
        selectNode._customSelectActiveGroup = selectNode.dataset.group ? selectNode.dataset.group : null;

        let wrapperNode = document.createElement('div');
        wrapperNode.classList.add('c-custom-select');
        if (selectNode.multiple) {
            wrapperNode.classList.add('c-custom-select--multiple');
        }

        // fake selected item
        let selectedNode = document.createElement('div');
        selectedNode.classList.add('c-custom-select__selected');
        selectedNode.onclick = () => {
            self[itemsNode.hidden ? '_open' : '_close'](selectNode);
        };
        selectNode._customSelectSelectedNode = selectedNode;

        // fake options
        let itemsNode = document.createElement('div');
        itemsNode.classList.add('c-custom-select__items');
        itemsNode.hidden = true;
        selectNode._customSelectItemsNode = itemsNode;

        // fake options - search bar
        noItemsNode = document.createElement('div');
        noItemsNode.classList.add('c-custom-select__items-no-items');
        noItemsNode.classList.add('c-custom-select__items-not-found');
        noItemsNode.innerText = self._translate('NoItems');
        noItemsNode.hidden = true;
        selectNode._customSelectNoItemsNode = noItemsNode;

        // fake options - search bar
        if (selectNode._customSelectEnableSearch) {
            let searchNode = document.createElement('input');
            searchNode.classList.add('c-custom-select__items-search');
            searchNode.type = 'search';
            searchNode.placeholder = self._translate('Searching');
            searchNode.oninput = () => {
                let phrase = self._sanitizeString(searchNode.value);
                selectNode._customSelectNode.classList[phrase ? 'add' : 'remove']('searching');
                selectNode._customSelectSanitizedSearchPhrase = phrase;
                self._updateItemsVisibilityState(selectNode);
            }

            itemsNode.appendChild(searchNode);
            selectNode._customSelectItemSearchNode = searchNode;
        }

        // fake options - options
        selectNode._customSelectItemsNodes = [];
        optionsNodes.forEach(optionNode => {
            let itemNode = document.createElement('div')
            itemNode.classList.add('c-custom-select__items-item');
            itemNode.innerHTML = optionNode.dataset.text ? optionNode.dataset.text : optionNode.innerText;
            itemNode._customSelectOptionNode = optionNode;
            itemNode._customSelectLabel = self._sanitizeString(optionNode.innerText.replace(/(<([^>]+)>)/gi, ""));
            itemNode.onclick = () => {
                itemNode.classList.add('selected');
                selectedNode.innerHTML = optionNode.dataset.text ? optionNode.dataset.text : optionNode.innerText;

                let selectedItemNode = itemsNode.querySelector('.selected');
                if (selectedItemNode) {
                    selectedItemNode.classList.remove('selected');
                }

                self._close(selectNode);
                selectNode.value = optionNode.value;
                selectNode.dispatchEvent(new Event('change'));
            };

            // search only visibility
            if (optionNode.dataset.visibility === 'search-only') {
                itemNode.hidden = true;
            }

            // groups
            itemNode._customSelectGroups = typeof optionNode.dataset.groups === 'string' ? optionNode.dataset.groups.split(',').map(group => {
              return group.trim();
            }).filter(group => {
                return Boolean(group);
            }) : null;

            itemNode._customSelectIsInActiveGroup = function () {
                if (selectNode._customSelectActiveGroup === null) {
                    return true;
                }

                if (itemNode._customSelectGroups === null) {
                    return false;
                }

                return itemNode._customSelectGroups.includes(selectNode._customSelectActiveGroup);
            };

            itemsNode.appendChild(itemNode);
            selectNode._customSelectItemsNodes.push(itemNode);
        });

        // selected option
        let selectedValue = null;
        for (let key in optionsNodes) {
            let optionNode = optionsNodes[key];
            if (optionNode.selected && optionNode.hasAttribute('selected')) {
                selectedValue = optionNode.value;
                break;
            }
        }

        self._updateSelectedItem(selectNode, selectedValue);
        self._updateItemsVisibilityState(selectNode);

        // build
        if (selectNode._customSelectEnableSearch) {
            itemsNode.appendChild(noItemsNode);
        }
        wrapperNode.appendChild(selectedNode);
        wrapperNode.appendChild(itemsNode);
        selectNode.parentNode.insertBefore(wrapperNode, selectNode.nextSibling);
        selectNode.classList.add('js-select-initialized');
        selectNode._customSelectNode = wrapperNode;
        selectNode.hidden = true;
    },

    _open(selectNode) {
        let self = this;

        self._updateItemsVisibilityState(selectNode);
        selectNode._customSelectItemsNode.hidden = false;
        selectNode._customSelectNode.classList.add('opened');
        if (self.openedSelectBox) {
            self._close(self.openedSelectBox);
        }

        self.openedSelectBox = selectNode;

        if (selectNode._customSelectEnableSearch) {
            document.addEventListener('keydown', self._swapKeyDownEvent);
        }
    },

    _close(selectNode) {
        let self = this;

        selectNode._customSelectNode.classList.remove('opened');
        selectNode._customSelectItemsNode.hidden = true;
        self._updateItemsVisibilityState(selectNode);
        self.openedSelectBox = null;

        if (selectNode._customSelectEnableSearch) {
            selectNode._customSelectItemSearchNode.value = '';
            selectNode._customSelectSanitizedSearchPhrase = null;
            document.removeEventListener('keydown', self._swapKeyDownEvent);
        }
    },

    _updateItemsVisibilityState(selectNode) {
        let hasVisibleItems = false;
        selectNode._customSelectItemsNodes.forEach((itemNode) => {
            if (! itemNode._customSelectIsInActiveGroup()) {
                itemNode.hidden = true;

                return;
            }

            if (
                ! selectNode._customSelectSanitizedSearchPhrase
                && itemNode._customSelectOptionNode.dataset.visibility === 'search-only'
                && ! itemNode._customSelectOptionNode.selected
            ) {

                itemNode.hidden = true;

                return;
            }

            if (selectNode._customSelectSanitizedSearchPhrase && itemNode._customSelectLabel.indexOf(selectNode._customSelectSanitizedSearchPhrase) === -1) {
                itemNode.hidden = true;

                return;
            }

            itemNode.hidden = false;
            hasVisibleItems = true;
        });

        selectNode._customSelectNoItemsNode.hidden = hasVisibleItems;
    },

    _updateSelectedItem(selectNode, selectedValue) {
        let self = this;

        let firstVisibleItemNode = null;
        let selectedVisibleItemNode = null;
        selectNode._customSelectItemsNodes.forEach(itemNode => {

            // select truly selected item
            if (selectedValue && selectedValue === itemNode._customSelectOptionNode.value && itemNode._customSelectIsInActiveGroup()) {
                selectedVisibleItemNode = itemNode;
                itemNode.hidden = false;

                return;
            }

            if (itemNode.hidden) {
                return;
            }

            if (firstVisibleItemNode === null) {
                firstVisibleItemNode = itemNode;
            }

            if (itemNode._customSelectOptionNode.value === selectNode.value) {
                selectedVisibleItemNode = itemNode;
            }
        });

        if (selectedVisibleItemNode) {
            selectNode._customSelectSelectedNode.innerHTML = selectedVisibleItemNode._customSelectOptionNode.dataset.text
                ? selectedVisibleItemNode._customSelectOptionNode.dataset.text
                : selectedVisibleItemNode._customSelectOptionNode.innerText;

            return;
        }

        if (firstVisibleItemNode) {
            selectNode.value = firstVisibleItemNode._customSelectOptionNode.value;
            selectNode._customSelectSelectedNode.innerHTML = firstVisibleItemNode._customSelectOptionNode.dataset.text
                ? firstVisibleItemNode._customSelectOptionNode.dataset.text
                : firstVisibleItemNode._customSelectOptionNode.innerText;

            return;
        }

        selectNode.value = null;
        selectNode._customSelectSelectedNode.innerHTML = self._translate('NoItems');
    },

    _sanitizeString(value) {
        value = value.toLowerCase();
        value = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        value = value.replace(/[\W_]+/g,'');

        // because of keyboard keys switch and i/y grammar issues
        value = value.replace(/z/g, 'y');
        value = value.replace(/y/g, 'i');

        return value;
    },

    _translate(key) {
        let self = this;

        if (typeof self.translations[document.documentElement.lang][key] === 'undefined') {
            return key;
        }

        return self.translations[document.documentElement.lang][key];
    },

    _swapKeyDownEvent(event) {
        if (event.target.classList.contains('c-custom-select__items-search')) {
            return;
        }

        document.querySelector('.c-custom-select.opened .c-custom-select__items-search').focus();
    },
};

CustomJsSelectBox.init();

document.addEventListener('LokiRequestEnd', function () {
    CustomJsSelectBox.init();
});
